import AppInfoContext from "src/provider/state-manager/appInfoProvider";
import {
  AbsoluteContainer,
  AppSpan,
  AppText,
  Button,
  CustomContainer,
  FlexRow,
  GridContainer,
} from "src/style";
import { useContext, useState } from "react";
import { IoArrowBackOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

interface CbpTemrsProp {
  onNext : () => void;
}
const CbpTermsCondition = ({onNext}: CbpTemrsProp) => {
  const {
    info: { institutionData },
  } = useContext(AppInfoContext);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  
  return (
    <CustomContainer className="cbp-container">
      <AppText
        textSize="2.2"
        fontWeight="700"
        color="#000000"
        align="center"
        bottomMargin="1.5"
      >
        {"Terms & Conditions"}
      </AppText>
      {isLoading && (
        <AbsoluteContainer
          top="0"
          left="0"
          zIndex="3"
          width="100"
          sizeUnit="%"
          height="full"
        >
          <GridContainer
            height="100"
            hUnit="%"
            bgColor="rgba(255, 255, 255, 0.5)"
          >
            <AppSpan
              textSize="4"
              color="#0D968F"
              className="fa fa-spinner fa-spin"
            />
          </GridContainer>
        </AbsoluteContainer>
      )}

      <iframe
        src={institutionData?.termsAndConditionsUrl}
        // width={"100%"}
        // height={"100vh"}
        allowFullScreen
        frameBorder="0"
        style={{flexGrow: 1}} 
        onLoad={() => setIsLoading(false)}
      />
        <Button
          width="100%"
          height="4"
          borderColor="#0D968F"
          hoverBgColor="#fff"
          hoverColor="#0D968F"
          titleSize="1.4"
          onClick={onNext}
        >
          Accept and Continue
        </Button>
    </CustomContainer>
  );
};

export default CbpTermsCondition;
